import React, {Component} from "react";
import {Trans, withTranslation} from "react-i18next";
import {Redirect} from "react-router-dom";
import {API_URL} from "../config";

class AppLostPassword extends Component {
    state = {};

    render() {
        //const {user} = this.props, {editingTaxResidence, editingTaxNo, editingIncome} = this.state;
        const {t} = this.props, {fetching, error, redirect} = this.state;
        if (redirect) return <Redirect to="/sent-confirmation"/>;
        return (
            <form onSubmit={this._handleSubmit.bind(this)}>
                <div className="Register-Content-Header">
                    <Trans i18nKey='resetPasswordTitle'>
                        <h1 className="Register-Heading">{t('resetPasswordTitle')}</h1>
                    </Trans>
                    <Trans i18nKey='resetPasswordSubtitle'>
                        <span className="Register-Subtitle">{t('resetPasswordText')}</span>
                    </Trans>
                    <div className="Register-Content-Body">
                        <div className="Register-Row">
                            <div className="Register-FormField Register-FormField--Next">
                                <input ref="email" type="email" name="email" className="Register-Input"
                                       placeholder={t('yourEmail')} required
                                       autoComplete="email"/>

                                <button disabled={fetching} type="submit" data-loading={fetching}
                                        className="Button Button--Next">
                                    <div className="Button__Loader"/>
                                </button>
                            </div>
                        </div>
                        <div className="Register-Row">
                            <span className="Register-FormField-Helper Register-FormField-Helper--Error">{error}</span>
                        </div>
                        {/*<Trans i18nKey='resetPasswordHere'>
                            <span className="Register-Subtitle">Lost password? <Link className="link" to={"/recover"}>Reset password</Link></span>
                        </Trans>*/}
                    </div>
                </div>
            </form>
        )
    }

    _handleSubmit(e) {
        e.preventDefault();

        const email = this.refs.email.value;

        this.setState({fetching: true});

        fetch(API_URL +"/lostPassword?username=" + encodeURIComponent(email), {
            method: 'get',
            headers: {
                //"Content-Type": "application/json",
                "Accept": "application/json",
            },
        }).then(res => {
            if (res.ok) {
                this.setState({error: '', redirect: true, fetching: false});
            } else {
                this.setState({error: window.trans("error-lost-password"), fetching: false});
            }
            console.log(res);
            /*if(res && res.message) {
                this.setState({error: window.trans(res.message), fetching: false});
                console.error(res.message)
            } else {
                this.setState({error: '', redirect: true, fetching: false});
            }*/
        }).catch(err => {
            this.setState({error: window.trans("error-lost-password"), fetching: false});
            console.error(err)
        });
    }
}

export default withTranslation('app')(AppLostPassword);